import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-row mt-3" }
const _hoisted_2 = { class: "field flex-1 mr-4" }
const _hoisted_3 = { class: "flex flex-row justify-content-between" }
const _hoisted_4 = { class: "field-checkbox mb-2" }
const _hoisted_5 = { class: "field w-6rem" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "dialog-footer flex justify-content-between" }

import { onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import { EMIT } from '@/enum';
import { useOrganizationTypeStore, useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddOrganization',
  emits: [EMIT.NEXT, EMIT.BACK],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const orgTypeStore = useOrganizationTypeStore();
const tenantStore = useTenantStore();

/**
 * same as tenant checkbox to handle assinging the tenant name to the org
 */
const checked = ref(false);

/**
 * The data ref object used to create the request payload.
 */
const { newOrganization } = storeToRefs(tenantStore);

/**
 * The required validation rules.
 */
const rules = {
  name: { required },
  acronym: {},
  org_type: { required },
};

/**
 * Initialize the vuelidate instance.
 */
const v$ = useVuelidate(rules, newOrganization);

onMounted(() => {
  init();
});

const init = async () => await orgTypeStore.getOrganizationTypes();

/**
 * Handle the client side validation, followed by saving the
 * information for the new user account.
 */
const onSave = () => {
  if (v$.value.$invalid) return;
  emit(EMIT.NEXT);
};

/**
 * if checbox selected then assign the org name as the tenant name, reverse if unselected
 */
const handleSameAsTenantCheckbox = () => {
  newOrganization.value.name = checked.value ? tenantStore.newTenant.name : '';
};

const goBack = () => emit(EMIT.BACK);

return (_ctx: any,_cache: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "required",
            for: "name"
          }, "Organization Name", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Checkbox, {
              modelValue: checked.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
              binary: true,
              onInput: handleSameAsTenantCheckbox
            }, null, 8, ["modelValue"]),
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Same as Tenant", -1))
          ])
        ]),
        _createVNode(_component_InputText, {
          id: "name",
          modelValue: _unref(v$).name.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).name.$model) = $event)),
          type: "text",
          placeholder: "Organization Name",
          class: "w-full"
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).name.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors"
          }, [
            _createElementVNode("small", null, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "address" }, "Acronym", -1)),
        _createVNode(_component_InputText, {
          id: "acronym",
          modelValue: _unref(v$).acronym.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).acronym.$model) = $event)),
          class: "w-full",
          maxlength: "5",
          type: "text",
          placeholder: "e.g ABC"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[7] || (_cache[7] = _createElementVNode("label", {
        class: "required",
        for: "org_type_id"
      }, "Organization Type", -1)),
      _createVNode(_component_Dropdown, {
        id: "org_type_id",
        modelValue: _unref(v$).org_type.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).org_type.$model) = $event)),
        options: _unref(orgTypeStore).types,
        "option-label": "title",
        "option-value": "title",
        placeholder: "Select a Type",
        class: "w-full"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_AppButton, {
        "icon-left": "arrow_back",
        type: "secondary",
        text: "Back",
        class: "ml-0 admin-button",
        onClick: goBack
      }),
      _createVNode(_component_AppButton, {
        "icon-left": "arrow_forward",
        type: "secondary",
        text: "Next",
        class: "admin-button cursor-pointer",
        disabled: _unref(v$).$invalid,
        onClick: onSave
      }, null, 8, ["disabled"])
    ])
  ], 64))
}
}

})